import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

class ConfiguratorHead extends React.Component {
    constructor() {
        super();
        this.state = { isCapOn: false };
        this.toggleCap = this.toggleCap.bind(this);
    }

    toggleCap() {
        if (!this.props.hasCap) {
            return;
        }

        this.props.toggleCap();
        this.setState({ isCapOn: !this.state.isCapOn });
    }

    render() {
        const { hasCap, resetConfig, toggleIntroductionLayer } = this.props;
        const capToggleClasses = ['icon'];

        if (!this.state.isCapOn) {
            capToggleClasses.push('is-off');
        }

        if (!hasCap) {
            capToggleClasses.push('is-disabled');
        }

        return (
            <div className="configurator__head">
                <h1 className="pen-name">{this.props.penName}</h1>
                <div className="controls">
                    <div
                        className="icon"
                        onClick={toggleIntroductionLayer}
                        title={this.props.texts['configurator.head.help.icon.title']}
                    >
                        <Isvg src="/svg/help.svg" />
                    </div>
                    <div
                        className={capToggleClasses.join(' ')}
                        id="toggle-pen-cap"
                        onClick={this.toggleCap}
                        title={this.props.texts['configurator.head.toggle.cap.icon.title']}
                    >
                        <div className="cap-on-icon">
                            <Isvg src="/svg/toggle-cap-on.svg" />
                        </div>
                        <div className="cap-off-icon">
                            <Isvg src="/svg/toggle-cap-off.svg" />
                        </div>
                    </div>
                    <div
                        className="icon"
                        onClick={resetConfig}
                        title={this.props.texts['configurator.head.reset.icon.title']}
                    >
                        <Isvg src="/svg/reset.svg" />
                    </div>
                </div>
            </div>
        );
    }
}

ConfiguratorHead.propTypes = {
    penName: PropTypes.string,
    resetConfig: PropTypes.func.isRequired,
    toggleCap: PropTypes.func.isRequired,
    hasCap: PropTypes.bool,
    toggleIntroductionLayer: PropTypes.func.isRequired,
    texts: PropTypes.object,
};

ConfiguratorHead.defaultProps = {
    penName: '',
    hasCap: false,
};

export default ConfiguratorHead;
